// extracted by mini-css-extract-plugin
export default {"shortTipsPc":"index_shortTipsPc_ga68Z","fhxwkhdPc":"index_fhxwkhdPc_0fDcl"};